import { sendTagEventNavigationCommon, TagDataLayer, TagEnvironnement } from '@axa-fr-axion/tag';
import { AppOptions, JourneyData } from 'App.interface';
import { StepNavigationPath } from 'interfaces';
import { DATA_LAYER_GLOBAL, getTagData } from './Tag.data';
import { getHashedDataLayer } from './Tag.utils';

export const sendTagEventNavigation = async (
    step: StepNavigationPath,
    journeyData: JourneyData,
    options: AppOptions | undefined = undefined,
) => {
    const hashedDataLayer = await getHashedDataLayer(journeyData);
    const navigationData: TagDataLayer | null =
        getTagData(journeyData.folder.personne?.profilClient?.toLowerCase())[ step ];
    const dataLayer = {
        ...DATA_LAYER_GLOBAL,
        entree: getEntree(options),
    };
    const environment = toTagEnvironment(process.env.REACT_APP_TARGETED_ENV);
    await sendTagEventNavigationCommon(hashedDataLayer, navigationData, dataLayer, environment);
};

const getOrDefault = (value: string | undefined): string => {
    return value || '';
};

const getEntree = (options: AppOptions | undefined): string => {
    const birthdateNomEtape = getTagData()[ 'VehicleIdentificationChoice' ]?.nom_etape;

    return getOrDefault(birthdateNomEtape);
};

function toTagEnvironment(env?: string): TagEnvironnement {
    switch (env?.toLowerCase()) {
        case 'production':
            return 'Prod';
        case 'staging':
            return 'Preprod';
        case 'testing':
            return 'Recette';
        case 'development':
        default:
            return 'Dev';
    }
}
